import Button from "../Button";
import Card from "../Card";
import Modal from "./Modal";
import gsap from 'gsap';
import { useGSAP } from '@gsap/react';
import { useRef } from "react";
import { sortCards } from "../../utility/cardUtils";

function StackModal({ cards, amount, onPlay, onTank }) {
    const cardsRef = useRef(null);

    useGSAP(() => {
        const tl = gsap.timeline();

        tl.fromTo(cardsRef.current, {
            opacity: 0.7,
        }, {
            opacity: 1,
            stagger: {
                amount: 0.1
            },
            ease: 'power1.out',
            duration: 0.333,
        }, 0)

        tl.fromTo(cardsRef.current.children, {
            y: -20,
        }, {
            y: 0,
            ease: 'power1.out',
            stagger: {
                amount: 0.333
            },
        }, 0);

        tl.fromTo('.st', {
            y: 8,
            opacity: 0,
        }, {
            y: 0,
            opacity: 1,
            ease: 'power1.out',
            duration: 0.15,
        }, 0.1)
    }, []);

    const sortedCards = sortCards(cards);

    const gridTemplateColumns = `repeat(${cards.length},64px)`

    return (
        <Modal>
            <div className="scrollbar mt-16 pt-1 max-w-[90%] overflow-x-auto overflow-y-visible">
                <div ref={cardsRef} className="inline-grid justify-center mr-16 mb-2" style={{ gridTemplateColumns: gridTemplateColumns }}>
                    {sortedCards.map((card, index) => {
                        return (
                            <div key={`plusTwo_${index}`} onClick={() => onPlay(card)} className={`w-32 mt-4 hover:pt-4 hover:mt-0 group/pt cursor-pointer relative`}>
                                <Card card={card} />
                            </div>
                        );
                    })}
                </div>
            </div>
            <Button onClick={onTank} text={`Tank +${amount}`} styling="secondary" className={'w-28 mt-4 st opacity-0 translate-y-2'}/>
        </Modal>
    );
}

export default StackModal;